import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default ({
  domain,
}) => new Promise((resolve) => {
  nsApi.get({
    domain,
    object: 'dashboard',
    action: 'list',
  }).then((res) => {
    resolve(res || []);
  }).catch((err) => {
    console.error(err);
    resolve(false);
  });
});
